// Validation for enriched hotel form (Exigences 6.5, 6.6)
import { HotelEnriched, HotelEnrichedErrors } from '../types/hotelEnriched';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_REGEX = /^\+?[\d\s\-()]{6,20}$/;

export function validateHotelEnrichedField(
  field: keyof HotelEnriched,
  value: any,
  formData: HotelEnriched
): string {
  switch (field) {
    case 'name':
      if (!value || String(value).trim() === '') return 'Le nom de l\'hôtel est obligatoire';
      break;
    case 'star_category':
      if (value !== null && value !== '' && value !== undefined) {
        const cat = Number(value);
        if (isNaN(cat) || cat < 1 || cat > 5) return 'La catégorie doit être entre 1 et 5 étoiles';
      }
      break;
    case 'email':
      if (value && String(value).trim() && !EMAIL_REGEX.test(String(value)))
        return 'Format d\'email invalide';
      break;
    case 'manager_email':
    case 'operational_manager_email':
      if (value && String(value).trim() && !EMAIL_REGEX.test(String(value)))
        return 'Format d\'email invalide';
      break;
    case 'owner_phone':
    case 'manager_phone':
    case 'operational_manager_phone':
    case 'hr_manager_phone':
      if (value && String(value).trim() && !PHONE_REGEX.test(String(value)))
        return 'Format de téléphone invalide (ex: +243 123 456 789)';
      break;
    case 'latitude':
      if (value !== null && value !== '' && value !== undefined) {
        const lat = Number(value);
        if (isNaN(lat) || lat < -90 || lat > 90) return 'La latitude doit être entre -90 et 90';
      }
      break;
    case 'longitude':
      if (value !== null && value !== '' && value !== undefined) {
        const lng = Number(value);
        if (isNaN(lng) || lng < -180 || lng > 180) return 'La longitude doit être entre -180 et 180';
      }
      break;
    case 'fpt_rate':
      if (formData.is_fpt_subject && value !== undefined) {
        const rate = Number(value);
        if (isNaN(rate) || rate < 0) return 'Le taux FPT doit être positif';
      }
      break;
    case 'total_rooms':
    case 'num_suites':
    case 'num_beds':
    case 'num_conference_rooms':
    case 'male_employees':
    case 'female_employees':
    case 'security_agents':
      if (value !== null && value !== '' && value !== undefined) {
        const num = Number(value);
        if (isNaN(num) || num < 0) return 'La valeur doit être un nombre positif ou zéro';
      }
      break;
  }
  return '';
}

export function validateHotelEnrichedForm(formData: HotelEnriched): HotelEnrichedErrors {
  const errors: HotelEnrichedErrors = {};
  const fieldsToValidate: (keyof HotelEnriched)[] = [
    'name', 'star_category', 'email', 'manager_email', 'operational_manager_email',
    'owner_phone', 'manager_phone', 'operational_manager_phone', 'hr_manager_phone',
    'latitude', 'longitude', 'fpt_rate', 'total_rooms', 'num_suites', 'num_beds',
    'num_conference_rooms', 'male_employees', 'female_employees', 'security_agents',
  ];
  for (const field of fieldsToValidate) {
    const error = validateHotelEnrichedField(field, formData[field], formData);
    if (error) errors[field] = error;
  }
  return errors;
}
